export enum CatalogMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_FAVORITES_LOADING = 'SET_FAVORITES_LOADING',
  SET_CATEGORIES = 'SET_CATEGORIES',
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_PRODUCTS_SEARCH = 'SET_PRODUCTS_SEARCH',
  SET_PRODUCTS_INFO = 'SET_PRODUCTS_INFO',
  RESET_PRODUCTS_PAGE = 'RESET_PRODUCTS_PAGE',
  SET_FILTERS = 'SET_FILTERS',
  SET_FAVORITES = 'SET_FAVORITES',
  SET_FAVORITES_INFO = 'SET_FAVORITES_INFO',
  SET_PRODUCT = 'SET_PRODUCT',
  SET_PACKAGING = 'SET_PACKAGING',
  SET_WISHLIST = 'SET_WISHLIST',
  SET_ALIGNMENT = 'SET_ALIGNMENT',
  SET_QUERIES = 'SET_QUERIES',
  SET_ERROR = 'SET_ERROR',
  SET_SHIP_TO = 'SET_SHIP_TO',
  SET_PRODUCT_WISHLIST = 'SET_PRODUCT_WISHLIST',
  SET_PRODUCT_WISHLIST_INFO = 'SET_PRODUCT_WISHLIST_INFO',
  SET_RECOMMENDED = 'SET_RECOMMENDED',
  SET_CATEGORIES_FILTER = 'SET_CATEGORIES_FILTER',
  SET_CONTINUE_MODAL_TITLE = 'SET_CONTINUE_MODAL_TITLE',
  SET_CONTINUE_MODAL_CONTINUE_MESSAGE = 'SET_CONTINUE_MODAL_CONTINUE_MESSAGE',
  SET_CONTINUE_MODAL_NEW_MESSAGE = 'SET_CONTINUE_MODAL_NEW_MESSAGE',
  SET_PACKAGE_LIMIT = 'SET_PACKAGE_LIMIT',
  ADD_PRODUCTS = 'ADD_PRODUCTS',
}
